export default __webpack_public_path__ + "static/media/typical_decorrelation_curve.4fc1a44d.png";